import { SET_CUSTOMER_NAME } from 'store/home/action';
import {
  loginComplete,
  logOut,
  FORGET_PASSWORD,
  HIDE_PRIVACY_POLICY_MODAL,
  HIDE_TERM_AND_CONDITION_MODAL,
  LOGIN,
  LOGIN_COMPLETE,
  LOG_OUT,
  LOG_OUT_COMPLETE,
  REGISTER_DRIVER,
  REGISTER_DRIVER_COMPLETE,
  RESET_PASSWORD,
  SHOW_PRIVACY_POLICY_MODAL,
  SHOW_TERM_AND_CONDITION_MODAL
} from 'store/login/action';
import {
  HIDE_ERROR_MODAL,
  STOP_LOADING,
  SHOW_ERROR_MODAL,
  START_LOADING
} from 'store/layout/action';
import { getConfig } from 'services/environment';
import { resolveCustomerName } from 'services/route.service';
import { isAccessTokenValid, isRefreshTokenValid } from 'store/SoapUtilities';
import { requestApi } from 'api/Api';

const BYPASS_ACTIONS = [
  "persist/REHYDRATE",
  "persist/PERSIST",
  SET_CUSTOMER_NAME,
  LOGIN,
  LOGIN_COMPLETE,
  LOG_OUT_COMPLETE,
  LOG_OUT,
  FORGET_PASSWORD,
  SHOW_TERM_AND_CONDITION_MODAL,
  HIDE_TERM_AND_CONDITION_MODAL,
  SHOW_PRIVACY_POLICY_MODAL,
  HIDE_PRIVACY_POLICY_MODAL,
  REGISTER_DRIVER,
  START_LOADING,
  STOP_LOADING,
  REGISTER_DRIVER_COMPLETE,
  RESET_PASSWORD,
  SHOW_ERROR_MODAL,
  HIDE_ERROR_MODAL,
];

async function fetchRefreshToken(dispatch, loginState, customerName) {
  const { refresh_token } = loginState || {};

  if (!refresh_token || !customerName) {
    dispatch(logOut("expired"));
    return null;
  }

  try {
    const data = {
      client_id: `${customerName}-token`,
      client_secret: getConfig.clientSecret,
      grant_type: 'refresh_token',
      refresh_token: refresh_token,
    }

    const response = await requestApi({
      url: `/auth/realms/${customerName}/protocol/openid-connect/token`,
      method: 'POST',
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    });

    dispatch(
      loginComplete({
        ...response.data,
        timestamp: Date.now(),
    }));

    return response.data
  } catch (error) {
    console.error("Refresh token failed", error);
    dispatch(logOut("expired"));
    return null;
  }
}

function handleTokenRefresh(loginState, dispatch) {
  if (!loginState) return false;

  const { access_token: accessToken, refresh_token: refreshToken, isAuthenticated } = loginState;

  if (!isAuthenticated || (!accessToken && !refreshToken)) {
    return false;
  }

  const accessValid = isAccessTokenValid(loginState);
  const refreshValid = isRefreshTokenValid(loginState);

  if (!accessValid && refreshValid) {
    return true;
  }

  if (!accessValid && !refreshValid) {
    dispatch(logOut("expired"));
    return false;
  }

  return false;
}

let refreshPromise = null;

export const refreshTokenMiddleware = (store) => (next) => async (action) => {
  const { homeState, loginState } = store.getState();

  if (BYPASS_ACTIONS.includes(action.type)) {
    return next(action);
  }

  const needsRefresh = handleTokenRefresh(loginState, store.dispatch);

  if (needsRefresh) {
    if (!refreshPromise) {
      const customer = resolveCustomerName(
        homeState?.customerName,
        window.location.pathname
      );
      refreshPromise = fetchRefreshToken(store.dispatch, loginState, customer)
        .finally(() => {
          refreshPromise = null;
        });
    }

    const refreshed = await refreshPromise;
    if (refreshed) {
      return next(action);
    }
    return;
  }

  return next(action);
}
